<script lang="ts">
import ModuleDocument from '@/generated/modules/ModuleDocument.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleDocument
})

</script>
